import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-no-history",
  "use": "icon-no-history-usage",
  "viewBox": "0 0 65 46",
  "content": "<symbol viewBox=\"0 0 65 46\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-no-history\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M57.6175 46L65 4.06621H31.9712L31.1358 0H15.1318L7 46H57.6175Z\" fill=\"#CFCFCF\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 6L7.37648 46H58L50.6682 6H0Z\" fill=\"#E6E6E6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol